import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import { type UnPaymentSchedulesModels } from '@store/Finance/AP/ApInvoices/ApInvoicesModels';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';

// export const RefundPaymentComponent: React.FC<{
//   formik: any;
//   onClose: () => void;
//   OperatingUnitOptions: any[];
//   treeSuppliersData: any[];
// }> = ({ formik, onClose, OperatingUnitOptions, treeSuppliersData }) => {
//   const { values, setFieldValue } = formik;
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const [invoices, setInvoices] = useState<UnPaymentSchedulesModels[]>([]);
//   const [selectedInvoice, setSelectedInvoice] = useState<string | null>(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [fetchError, setFetchError] = useState<string | null>(null);

//   useEffect(() => {
//     if (selectedInvoice) {
//       setSelectedInvoice(null);
//       setInvoices([]);
//       setFetchError(null);
//     }
//   }, [values.peopleId, values.organizationId]);

//   const handleGetUnpaidInvoices = async () => {
//     if (!values.organizationId || !values.peopleId) return;

//     setIsLoading(true);
//     setFetchError(null);

//     try {
//       const result = await dispatch(
//         fetchUnpaidInvoices({
//           peopleId: values.peopleId,
//           organizationId: values.organizationId,
//           invoiceType: 'CreditMemo'
//         })
//       ).unwrap();

//       if (result.succeeded) {
//         const invoicesWithType = result.data.map((invoice: any) => ({
//           ...invoice,
//           invoiceType: 'Refund'
//         }));
//         setInvoices(invoicesWithType);
//         if (result.data.length === 0) {
//           setFetchError('لم يتم العثور على فواتير مرتجعات');
//         }
//       } else {
//         setFetchError('فشل في جلب فواتير المرتجعات');
//       }
//     } catch (error) {
//       console.error('Error fetching refund invoices:', error);
//       setFetchError('فشل في جلب فواتير المرتجعات');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRadioChange = (paymentScheduleId: string) => {
//     setSelectedInvoice(paymentScheduleId);
//   };
// // console.log(selectedInvoice);
// // console.log(invoices);

//   const handleSubmit = () => {
//     if (!selectedInvoice) return;

//     const selectedInvoiceData = invoices.find(invoice => invoice.apPaymentScheduleId === selectedInvoice);

//     if (selectedInvoiceData) {
//       const formattedInvoice = {
//         id: null,
//         apPaymentScheduleId: selectedInvoiceData.apPaymentScheduleId,
//         invoiceNum: selectedInvoiceData.invoiceNum,
//         invoiceDate: selectedInvoiceData.invoiceDate,
//         dueDate: selectedInvoiceData.dueDate,
//         invoiceAmount: selectedInvoiceData.invoiceAmount,
//         schadualAmount: selectedInvoiceData.amount,
//         amount: selectedInvoiceData.remainingAmount,
//         actualRemainingAmount: selectedInvoiceData.remainingAmount,
//         invoiceType: selectedInvoiceData.invoiceType
//       };
//  debugger
//       // formik?.setFieldValue('scheduleList', [formattedInvoice]);
//       formik?.setFieldValue('scheduleList', []);
//       formik?.setFieldValue('creditMemoInvoiceId', selectedInvoice);
//       onClose();
//     }
//   };

//   const columns = [
//     {
//       title: '',
//       key: 'radio',
//       render: (value: any, record: any) => (
//         <div className='form-check'>
//           <input
//             type='radio'
//             className='form-check-input'
//             name='refundInvoice'
//             checked={selectedInvoice === record.invoiceId}
//             onChange={() => handleRadioChange(record.invoiceId)}
//           />
//         </div>
//       )
//     },
//     {
//       title: 'نوع الفاتورة',
//       key: 'invoiceType',
//       render: (value: any, record: any) => <span className='badge bg-warning'>مرتجع</span>
//     },
//     // { title: 'رقم الدفع', key: 'paymentNum' },
//     { title: 'رقم الفاتورة', key: 'invoiceNum' },
//     { title: 'تاريخ الفاتورة', key: 'invoiceDate' },
//     { title: 'مبلغ الفاتورة', key: 'invoiceAmount' },
//     { title: 'المبلغ المتبقي', key: 'remainingAmount' },
//     { title: 'تاريخ الاستحقاق', key: 'dueDate' }
//   ];

//   const sortedInvoices = [...invoices].sort((a, b) => {
//     return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
//   });

//   const tableData: any[] = sortedInvoices.map(invoice => ({
//     apPaymentScheduleId: invoice.apPaymentScheduleId,
//     radio: invoice.apPaymentScheduleId,
//     invoiceType: invoice.invoiceType,
//     paymentNum: invoice.paymentNum,
//     invoiceNum: invoice.invoiceNum,
//     invoiceDate: invoice.invoiceDate,
//     invoiceAmount: <span className='fw-bold text-primary'>{Number(invoice.invoiceAmount).toLocaleString()}</span>,
//     remainingAmount: <span className='fw-bold text-success'>{Number(invoice.remainingAmount).toLocaleString()}</span>,
//     dueDate: invoice.dueDate
//   }));

//   const selectedInvoiceData = invoices.find(invoice => invoice.apPaymentScheduleId === selectedInvoice);
//   const selectedAmount = selectedInvoiceData ? selectedInvoiceData.remainingAmount : 0;

//   const isFormValid = selectedInvoice !== null;

//   return (
//     <div>
//       <div className='row g-3 mb-4'>
//         <div className='col-lg-6'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>المورد</label>
//             <TreeSelect
//               showSearch
//               className='w-100'
//               treeLine
//               placeholder='اختر المورد'
//               allowClear
//               treeDefaultExpandAll={false}
//               value={values.peopleId}
//               onChange={option => {
//                 setSelectedInvoice(null);
//                 setInvoices([]);
//                 formik.setFieldValue('peopleId', option === null ? null : option);
//               }}
//               treeData={treeSuppliersData}
//               treeNodeFilterProp='title'
//               getPopupContainer={triggerNode => triggerNode.parentNode}
//             />
//           </div>
//         </div>

//         <div className='col-lg-4'>
//           <div className='form-group'>
//             <label className='form-label fw-bold'>الوحدة التشغيلية</label>
//             <Select
//               isSearchable={true}
//               isClearable
//               options={OperatingUnitOptions}
//               value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//               onChange={(option: any) => {
//                 setSelectedInvoice(null);
//                 setInvoices([]);
//                 setFieldValue('organizationId', option === null ? null : option.value);
//               }}
//               placeholder='اختر الوحدة التشغيلية'
//               className='react-select-container'
//               classNamePrefix='react-select'
//             />
//           </div>
//         </div>

//         <div className='col-lg-2'>
//           <div className='form-group h-100 d-flex flex-column justify-content-end'>
//             <button
//               disabled={isLoading || !values.organizationId || !values.peopleId}
//               type='button'
//               className='btn btn-sm btn-outline-theme w-100 py-2'
//               onClick={handleGetUnpaidInvoices}
//             >
//               {isLoading ? (
//                 <>
//                   <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
//                   جاري التحميل...
//                 </>
//               ) : (
//                 <>
//                   <i className='fas fa-download me-2'></i>
//                   جلب المرتجعات
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       {fetchError && (
//         <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
//           <i className='fas fa-exclamation-triangle me-2'></i>
//           <div>{fetchError}</div>
//         </div>
//       )}

//       {tableData.length > 0 && (
//         <Card className='mb-4'>
//           <div className='card-header d-flex justify-content-between align-items-center'>
//             <h6 className='mb-0'>
//               <i className='fas fa-rotate-left me-2'></i>
//               قائمة فواتير المرتجعات
//               <span className='badge bg-warning ms-2'>مرتجعات</span>
//             </h6>
//             {/* <div>
//               <span className='badge bg-theme me-2'>فاتورة مختارة: {selectedInvoice ? 1 : 0}</span>
//               <span className='badge bg-success'>المبلغ: {selectedAmount.toLocaleString()}</span>
//             </div> */}
//           </div>

//           <div className='card-body p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='table-actived fw-bold'>
//                   <tr>
//                     {columns.map((col, index) => (
//                       <th key={index} className='text-center small'>
//                         {col.title}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tableData.map((row, rowIndex) => (
//                     <tr
//                       key={rowIndex}
//                       className={selectedInvoice === sortedInvoices[rowIndex].apPaymentScheduleId ? 'table-active' : ''}
//                     >
//                       {columns.map((col, colIndex) => (
//                         <td key={colIndex} className='text-center align-middle'>
//                           {col.render ? col.render(row[col.key], row) : row[col.key]}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           <div className='card-footer d-flex justify-content-between align-items-center'>
//             <div className='text-muted small'>
//               عرض {tableData.length} من {tableData.length} مرتجع
//             </div>
//             <div className='text-theme fw-bold'>المبلغ المحدد: {selectedAmount.toLocaleString()}</div>
//           </div>
//         </Card>
//       )}

//       <div className='border-top mt-4 pt-4'>
//         <div className='d-flex justify-content-between align-items-center'>
//           <div>
//             {isFormValid && (
//               <div className='alert alert-success d-flex align-items-center py-2 mb-0' role='alert'>
//                 <i className='fas fa-check-circle me-2'></i>
//                 <div>جاهز لاسترداد المبلغ المحدد</div>
//               </div>
//             )}
//           </div>

//           <div className='d-flex'>
//             <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
//               <i className='fas fa-rotate-left me-2'></i>
//               استرداد المبلغ
//             </button>

//             <button
//               type='button'
//               className='btn btn-outline-secondary'
//               onClick={() => navigate('/Finance/Ap/ApPayments', { replace: true })}
//             >
//               <i className='fas fa-times me-2'></i>
//               إلغاء
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

export const RefundPaymentComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeSuppliersData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeSuppliersData }) => {
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [invoices, setInvoices] = useState<UnPaymentSchedulesModels[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  useEffect(() => {
    if (selectedInvoice) {
      setSelectedInvoice(null);
      setInvoices([]);
      setFetchError(null);
    }
  }, [values.peopleId, values.organizationId]);

  const handleGetUnpaidInvoices = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const result = await dispatch(
        fetchUnpaidInvoices({
          peopleId: values.peopleId,
          organizationId: values.organizationId,
          invoiceType: 'CreditMemo'
        })
      ).unwrap();

      if (result.succeeded) {
        const invoicesWithType = result.data.map((invoice: any) => ({
          ...invoice,
          invoiceType: 'Refund'
        }));
        setInvoices(invoicesWithType);
        if (result.data.length === 0) {
          setFetchError('لم يتم العثور على فواتير مرتجعات');
        }
      } else {
        setFetchError('فشل في جلب فواتير المرتجعات');
      }
    } catch (error) {
      console.error('Error fetching refund invoices:', error);
      setFetchError('فشل في جلب فواتير المرتجعات');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRadioChange = (invoiceId: string) => {
    setSelectedInvoice(invoiceId);
  };

  // console.log(selectedInvoice);

  const handleSubmit = () => {
    if (!selectedInvoice) return;
    // formik?.setFieldValue('creditMemoInvoiceId', selectedInvoice);
    // onClose();

    const selectedInvoiceData = invoices.find(invoice => invoice.invoiceId === selectedInvoice);
    if (selectedInvoiceData) {
      formik?.setFieldValue('scheduleList', []);
      formik?.setFieldValue('creditMemoInvoiceId', selectedInvoice);
      formik?.setFieldValue('amount', selectedInvoiceData.remainingAmount);
      onClose();
    }
    // const selectedInvoiceData = invoices.find(invoice => invoice.invoiceId === selectedInvoice);
    // if (selectedInvoiceData) {
    //   const formattedInvoice = {
    //     id: null,
    //     apPaymentScheduleId: selectedInvoiceData.apPaymentScheduleId,
    //     invoiceNum: selectedInvoiceData.invoiceNum,
    //     invoiceDate: selectedInvoiceData.invoiceDate,
    //     dueDate: selectedInvoiceData.dueDate,
    //     invoiceAmount: selectedInvoiceData.invoiceAmount,
    //     schadualAmount: selectedInvoiceData.amount,
    //     amount: selectedInvoiceData.remainingAmount,
    //     actualRemainingAmount: selectedInvoiceData.remainingAmount,
    //     invoiceType: selectedInvoiceData.invoiceType
    //   };

    //   formik?.setFieldValue('scheduleList', []);
    //   formik?.setFieldValue('creditMemoInvoiceId', selectedInvoice);
    //   onClose();
    // }
  };

  const sortedInvoices = [...invoices].sort((a, b) => {
    return new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime();
  });

  const selectedInvoiceData = invoices.find(invoice => invoice.apPaymentScheduleId === selectedInvoice);
  const selectedAmount = selectedInvoiceData ? selectedInvoiceData.remainingAmount : 0;

  const isFormValid = selectedInvoice !== null;

  // console.log(sortedInvoices);

  return (
    <div>
      <div className='row g-3 mb-4'>
        <div className='col-lg-6'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المورد</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر المورد'
              allowClear
              treeDefaultExpandAll={false}
              value={values.peopleId}
              onChange={option => {
                setSelectedInvoice(null);
                setInvoices([]);
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeSuppliersData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-4'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                setSelectedInvoice(null);
                setInvoices([]);
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group h-100 d-flex flex-column justify-content-end'>
            <button
              disabled={isLoading || !values.organizationId || !values.peopleId}
              type='button'
              className='btn btn-sm btn-outline-theme w-100 py-2'
              onClick={handleGetUnpaidInvoices}
            >
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                  جاري التحميل...
                </>
              ) : (
                <>
                  <i className='fas fa-download me-2'></i>
                  جلب المرتجعات
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {fetchError && (
        <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-exclamation-triangle me-2'></i>
          <div>{fetchError}</div>
        </div>
      )}

      {sortedInvoices.length > 0 && (
        <Card className='mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-rotate-left me-2'></i>
              قائمة فواتير المرتجعات
              <span className='badge bg-warning ms-2'>مرتجعات</span>
            </h6>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'></th>
                    <th className='text-center small'>نوع الفاتورة</th>
                    <th className='text-center small'>رقم الفاتورة</th>
                    <th className='text-center small'>تاريخ الفاتورة</th>
                    <th className='text-center small'>مبلغ الفاتورة</th>
                    <th className='text-center small'>المبلغ المتبقي</th>
                    <th className='text-center small'>تاريخ الاستحقاق</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedInvoices.map((invoice, index) => (
                    <tr key={index} className={selectedInvoice === invoice.invoiceId ? 'table-active' : ''}>
                      <td className='text-center align-middle'>
                        <div className='form-check'>
                          <input
                            type='radio'
                            className='form-check-input'
                            name='refundInvoice'
                            checked={selectedInvoice === invoice.invoiceId}
                            onChange={() => handleRadioChange(invoice.invoiceId)}
                          />
                        </div>
                      </td>
                      <td className='text-center align-middle'>
                        <span className='badge bg-warning'>مرتجع</span>
                      </td>
                      <td className='text-center align-middle'>{invoice.invoiceNum}</td>
                      <td className='text-center align-middle'>{invoice.invoiceDate}</td>
                      <td className='text-center align-middle fw-bold text-primary'>
                        {Number(invoice.invoiceAmount).toLocaleString()}
                      </td>
                      <td className='text-center align-middle fw-bold text-success'>
                        {Number(invoice.remainingAmount).toLocaleString()}
                      </td>
                      <td className='text-center align-middle'>{invoice.dueDate?.toString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-between align-items-center'>
            <div className='text-muted small'>
              عرض {sortedInvoices.length} من {sortedInvoices.length} مرتجع
            </div>
            <div className='text-theme fw-bold'>المبلغ المحدد: {selectedAmount.toLocaleString()}</div>
          </div>
        </Card>
      )}

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            {/* {isFormValid && (
              <div className='alert alert-success d-flex align-items-center py-2 mb-0' role='alert'>
                <i className='fas fa-check-circle me-2'></i>
                <div>جاهز لاسترداد المبلغ المحدد</div>
              </div>
            )} */}
          </div>

          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-rotate-left me-2'></i>
              إستمرار
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
